import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { FormularioFamiliar } from "./FormularioFamiliar";
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Button, Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import MuiAlert from "@material-ui/lab/Alert";
import { ListaDocumentacionFAmiliares } from "../Documentacion/ListaDocumentacionFamiliares";
import { ListaDocumentacionFAmiliareStage } from "../Documentacion/ListaDocumentacionFamiliarStage";
import { grupoFamiliarSetTab } from "../../actions/familiarSeleccionado";
import { CertificadosPreAfiliado } from "./CertificadosPreAfiliado";
import { TIPO_CERTIFICADOS } from "../../utils/constants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  botonera: {
    marginTop: 25,
  },
  rootList:{
    margin:30
  },
  avisoEstado:{
    width: 600,
    margin:30
  }
}));

export const ModalFamiliarAlta = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch=useDispatch()
  const {documentacionCompleta,familiarAfiliadoSeleccionado, familiarStagePreafiliadoSeleccionado,familiarSeleccionado, tab} = useSelector((state) => state.familiarSeleccionado);
  const { cargada, items: certificados } = useSelector((state) => state.certificadosAfiliacion);

  function Alert(props) {
    return <MuiAlert className={classes.avisoEstado} elevation={6} variant="filled" {...props} />;
  }

  const handleChange = (event, newValue) => {
    if(newValue===0){
      dispatch( grupoFamiliarSetTab(newValue) );
    }
    // if(valueLocationModif && newValue!==0){
    if(newValue!==0 && (Object.keys(familiarAfiliadoSeleccionado).length > 0 || Object.keys(familiarSeleccionado).length > 0 ||Object.keys(familiarStagePreafiliadoSeleccionado).length > 0)){
      dispatch( grupoFamiliarSetTab(newValue) );
    }
  };

  const returnFamiliar = () => {
    if(Object.keys(familiarAfiliadoSeleccionado).length>0){
      return familiarAfiliadoSeleccionado;
    }else if(Object.keys(familiarSeleccionado).length>0){
      return familiarSeleccionado;
    }else if(Object.keys(familiarStagePreafiliadoSeleccionado).length>0){
      return familiarStagePreafiliadoSeleccionado;
    }
  }
  const certIncompleto = returnFamiliar()?.incapacitado===1 && certificados.filter(s => s.tipoCertificado === TIPO_CERTIFICADOS.DISCAPACIDAD).length === 0;

  return (
    <div className={classes.root}>
      <Dialog
        maxWidth="lg"
        fullWidth={true}
        className={classes.root}
        open={props.open}
        aria-labelledby="form-dialog-title"
      >
        <AppBar position="static" color="default">
          <Tabs
            value={tab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="Alta Familiar" {...a11yProps(0)} />
            <Tab label="Documentación" {...a11yProps(1)} />
            <Tab label="Certificados" {...a11yProps(2)} />
          </Tabs>
        </AppBar>

      
        <TabPanel  value={/* props.value */ tab} index={0} dir={theme.direction}>
          <FormularioFamiliar handleClose={props.handleClose} idGrupo={props.idGrupo}/* setValue={props.setValue} *//>
        </TabPanel>
        <TabPanel  value={/* props.value */ tab} index={1}>
            <Grid className={classes.rootList} container item justify="center">
              {!documentacionCompleta ? (
                <Alert severity="info">Documentación Incompleta</Alert>
              ) : (
                <Alert severity="success">Documentación Completa</Alert>
              )}
              {Object.keys(familiarAfiliadoSeleccionado).length !==0&&<ListaDocumentacionFAmiliares />}
              {Object.keys(familiarSeleccionado).length !==0&&<ListaDocumentacionFAmiliares idListaDoc={"idListDocPreinscripto"}  idListFami="idListFami"/>}
              {Object.keys(familiarStagePreafiliadoSeleccionado).length !==0&&<ListaDocumentacionFAmiliareStage />}
            </Grid>
            <Grid container item justify="flex-end">
              <Button 
                variant="contained"
                color="secondary"
                size="small"
                disabled={!documentacionCompleta || certIncompleto}
                className={classes.botonera}
                onClick={props.handleClose}
              >
                Cerrar
              </Button>
              {returnFamiliar()?.incapacitado===1 &&
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  style={{marginLeft:30}}
                  className={classes.botonera}
                  disabled={!documentacionCompleta}
                  onClick={(e) => {handleChange(e,2)}}
                >
                  Continuar
                </Button>
              }
            </Grid>
        </TabPanel>
        <TabPanel value={tab} index={2} >
          <CertificadosPreAfiliado 
            afiliado={returnFamiliar()}
            handleCloseTab={props.handleClose}
            certIncompleto={certIncompleto}
            certificados={certificados}
            cargada={cargada}
          />
        </TabPanel>
      </Dialog>
    </div>
  );
};
